// @flow
import styled from "styled-components";

import colors from '../../assets/css/colors';
import { below } from "../../assets/css/media";

export const DraftOrder = styled.input`
	display: flex;
	font-size: 16px;
	align-items: center;
	justify-content: center;
	height: 50px;
	width: 75px;
	border: 1px solid #C0C0C0;
	font-weight: bold;
	color: ${colors.darkGrey};
	background: #ffffff;
	margin-right: .3em;
	text-align: center;

	${below.phone`
		width: 40px;
		height: 40px;
		font-size: 14px;
	`};
`;

export default DraftOrder;


// WEBPACK FOOTER //
// ./src/components/Draft/DraftOrder.js